import type { FunctionComponent, ReactNode, Ref } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import type { SwiperProps, SwiperRef } from "swiper/react";

import { StyledSwiper } from "./styles";

type Props = SwiperProps & {
  children?: ReactNode;
  className?: string;
  ref?: Ref<SwiperRef>;
};

export const Swiper: FunctionComponent<Props> = ({ children, className, ...props }) => (
  <StyledSwiper
    className={className}
    cssMode
    modules={[Navigation, Pagination]}
    navigation
    pagination={{
      clickable: true,
    }}
    {...props}
  >
    {children}
  </StyledSwiper>
);

Swiper.displayName = "Swiper";
